export const number = v => v !== null && v !== '' && v !== undefined && Number.isFinite(Number(v)) ? Number(v) : null;
export const normalizeStocks = doc => {
 const source = doc?.stocks || doc?.results || [];
 return (Array.isArray(source) ? source : Object.entries(source).map(([code,s])=>({...s,code}))).filter(Boolean).map(s=>({
 ...s, name:s.name || s.basic_info?.stock_name || s.code,
 date:s.data_date || s.timestamps?.data_date || doc?.metadata?.data_date || doc?.metadata?.analysis_date?.slice(0,10),
 price:number(s.price_info?.current_price ?? s.current_price), change:number(s.price_info?.change_1d ?? s.price_change_rate),
 score:number(s.scores?.total_score), rs:number(s.scores?.details?.rs?.rs_rating),
 }));
};
export const normalizeETF = doc => ({
 date:doc?.metadata?.data_date || doc?.collection_info?.date,
 etfs:Object.entries(doc?.etfs || {}).filter(([,e])=>e && typeof e==='object').map(([code,e])=>({...e,code,name:e.name || e.basic_info?.name || code,theme:e.theme || e.basic_info?.theme || '미분류'})),
 themes:Object.entries(doc?.theme_summary || {}).filter(([,t])=>t && typeof t==='object').map(([name,t])=>({...t,name:t.theme || name.replace(/_/g,'/'),returns:t.avg_returns || t.average_returns || {}}))
});
export const format = (v,d=1) => number(v)===null ? '—' : Number(v).toLocaleString('ko-KR',{maximumFractionDigits:d});
export const percent = v => number(v)===null ? '—' : `${v>0?'+':''}${format(v,2)}%`;
